$(document).ready(function () {
	// variables
	var navToggle = $('.js-nav-toggle');
	var userHeaderMenu = $('.header-user-menu .crewards-status-info');
	var searchForm = $('.js-search-form');
	var searchToggle = $('.js-search-toggle');
	var mblHeaderSignIn = $('a.mobile-sign-in')

	// click events
	navToggle.on('click', function (e) { e.stopPropagation(); toggleNav(e); });
	userHeaderMenu.on('click', function (e) { if (e.target.className != 'sign-in-link') { e.stopPropagation(); toggleHeaderUserMenu(e); } });
	searchToggle.on('click', function (e) { e.stopPropagation(); toggleSearch(e); });
	mblHeaderSignIn.on('click', function (e) { toggleNav(e); navToggle.toggleClass('open'); });

	// search form on enter input or button
	searchForm.find('.form-control').on('keydown', function (e) { if (e.keyCode === 13) { searchTerm(e); } });
	searchForm.find('button').on('click', function (e) { searchTerm(e); });

	$('.js-nav-toggle-children').on('click', function (e) { mobileNavItem(e); });
    $('.nav .crewards-status-info.signed-in-status-info').on('click', function (e) { mobileCrewardsMenu(e); });

	// prevent closing menus when clicking on menu itself
	$('.crewards-status-dropdown').on('click', function (e) { 		
        e.stopPropagation(); 
		//allow modal pop-up for qr code
		if ($(e.target).closest('#qrcodelistitem').length) {
			$('#qr-code-modal').modal({show: true, backdrop: 'static', keyboard: false});
			$('.qrcodetext').html(window.MEMBER_CARD_NUMBER);
			$('.qridtext').html(window.MEMBER_ID);				
		}
		//if (e.target.tagName === "IMG" || e.target.tagName === "CANVAS") {
		//	$('#qr-code-modal').modal({show: true, backdrop: 'static', keyboard: false});
		//	$('.qrcodetext').html(window.MEMBER_CARD_NUMBER);
		//}
	});

	$('.search-mobile').on('click', function (e) { e.stopPropagation(); });

	$(document).click(function () {
		//Hide the menus if visible when clicking outside of them
		$('.search-mobile').removeClass('open');
		$('.search-mobile').slideUp();

        var parent = $('.crewards-status-content');

        if ($(parent).hasClass('open')) {
            $(parent).removeClass('open');
            $(parent).find('ul').slideUp();
        }
	});

	function mobileCrewardsMenu(e) {
		e.preventDefault();
		var parent = $('.crewards-status');

		$(parent).find('ul').slideToggle();
		$(parent).toggleClass('open');
	}

	function toggleNav(e) {
		var target = $(e.currentTarget);

		if ($('.search-mobile').hasClass('open')) {
			$('.search-mobile').toggleClass('open');
			$('.search-mobile').slideToggle();
		}

		target.toggleClass('open');
		$('.nav').slideToggle();
		$('body').toggleClass('nav-open');
	}

	function toggleSearch(e) {
		if (navToggle.hasClass('open')) {
			navToggle.toggleClass('open');
			$('.nav').slideToggle();
			$('body').toggleClass('nav-open');
		}

		$('.search-mobile').toggleClass('open');

		$('.search-mobile').slideToggle("slow", function () {
			$('.search-mobile .form-control').focus();
		});
	}

	function searchTerm(e) {
		e.preventDefault();

        var target = $(e.currentTarget).closest('div');
		var input = $(target).find('.form-control');
        var value = $(input).val();

        //window.location.href = '/search/#!?term=' + value;
		window.location.href = '/search?term=' + value;
	}

	function toggleHeaderUserMenu(e) {
		var parent = $(userHeaderMenu).parent();
		$(parent).toggleClass('open');
		$(parent).find('ul').slideToggle();
	}

	// clicking on items in mobile nav
	function mobileNavItem(e) {
		e.preventDefault();
		var target = $(e.currentTarget);
		var parent = target.closest('li');
		 
		$(parent).find('> ul').slideToggle();
		$(parent).toggleClass('open');
	}


    //remove mobile nav toggled if width goes above 900 and mobile tab is still open
    var DesktopNavWidth = 900;
    $(window).on('resize', function () {
        if ($(this).width() >= DesktopNavWidth) {
            if ($("body").hasClass( "nav-open" )) {
				if ($('.search-mobile').hasClass('open')) {
					$('.search-mobile').toggleClass('open');
					$('.search-mobile').slideToggle();
				}

			$('.nav-toggle.js-nav-toggle').removeClass('open');
			$('.nav').slideToggle();
			$('body').toggleClass('nav-open');
            }
        }
    });
});